var render, staticRenderFns
import script from "./TransitionGroupExpand.vue?vue&type=script&lang=js&"
export * from "./TransitionGroupExpand.vue?vue&type=script&lang=js&"
import style0 from "./TransitionGroupExpand.vue?vue&type=style&index=0&id=467d89d1&scoped=true&lang=css&"
import style1 from "./TransitionGroupExpand.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467d89d1",
  null
  
)

export default component.exports